import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_VERIFICAIONS_TAX } from "..";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";
import { GetMissingFieldsLevelParameter } from "@wingspanhq/wingspan-api-sdk";

export const RouteTaxVerificaiton: React.FC = () => {
  const history = useHistory();
  const queryFeatureFlags = useFeatureFlags();

  const modules = useMemo(
    (): OnboardingModule[] => [
      {
        type: "create_account",
        options: {
          accountTypes: ["Individual", "Business"],
          verificationLevel: GetMissingFieldsLevelParameter.TAX,
          allowUSInternationalPerson:
            queryFeatureFlags.data?.internationalUsPerson
        },
        title: "Tax verification"
      }
    ],
    [queryFeatureFlags.data?.internationalUsPerson]
  );

  return (
    <OnboardingFlow
      basePath={PATH_ONBOARDING_VERIFICAIONS_TAX}
      modules={modules}
      onSuccess={() => {
        history.push("/member");
      }}
    />
  );
};
